import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../config/api';
import SEO from '../components/SEO';
import './Information.css';
import './Gdpr.css';

const Gdpr = () => {
  const { t, i18n } = useTranslation();
  const [contentFi, setContentFi] = useState('');
  const [contentEn, setContentEn] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGdpr = async () => {
      try {
        const response = await axios.get(`${API_URL}/settings/gdpr`);
        setContentFi(response.data.gdprFi || '');
        setContentEn(response.data.gdprEn || '');
      } catch (err) {
        console.error('Error fetching GDPR content:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchGdpr();
  }, []);

  const isEn = (i18n.language || '').toLowerCase().startsWith('en');
  const content = isEn ? (contentEn || contentFi) : (contentFi || contentEn);

  const blocks = (content || '')
    .split(/\n\n+/)
    .map((block) => block.trim())
    .filter(Boolean);

  const hasContentFromSettings = blocks.length > 0;
  const introLocale = t('gdpr.intro');
  const bodyLocale = t('gdpr.body');
  const blocksFromLocale = (bodyLocale || '')
    .split(/\n\n+/)
    .map((b) => b.trim())
    .filter(Boolean);

  if (loading) {
    return (
      <div className="information-container gdpr-page">
        <div className="container">
          <p>{t('admin.loading') || 'Loading...'}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="information-container gdpr-page">
        <div className="container">
          <p className="error-message">{t('generalTerms.loadError') || 'Could not load content.'}</p>
        </div>
      </div>
    );
  }

  const showFromSettings = hasContentFromSettings;
  const intro = showFromSettings ? (blocks[0] && !blocks[0].startsWith('## ') ? blocks[0] : '') : introLocale;
  const bodyBlocks = showFromSettings
    ? (blocks[0] && !blocks[0].startsWith('## ') ? blocks.slice(1) : blocks)
    : blocksFromLocale;

  return (
    <div className="information-container gdpr-page">
      <SEO title={t('gdpr.title')} description="Rekisteriseloste ja tietosuoja – henkilötietojen käsittely GDPR:n mukaisesti." path="/gdpr" />
      <div className="container">
        <h1 className="gdpr-title">{t('gdpr.title')}</h1>
        <div className="information-content gdpr-content">
          {intro && (
            <p className="gdpr-intro">{intro}</p>
          )}
          <div className="gdpr-body">
            {bodyBlocks.length === 0 && !intro ? (
              <p className="gdpr-paragraph">{t('gdpr.empty') || 'GDPR / tietosuojaseloste ei ole vielä julkaistu.'}</p>
            ) : (
              bodyBlocks.map((block, i) => {
                if (block.startsWith('## ')) {
                  return (
                    <h2 key={i} className="gdpr-section-title">
                      {block.slice(3).trim()}
                    </h2>
                  );
                }
                return (
                  <p key={i} className="gdpr-paragraph">
                    {block}
                  </p>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gdpr;
